import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class FatigueTestsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      data: [],
      data_modal: [],
      applicabilities_list: [],
      staff_list: [],
      origins_list: [],
      status_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.search = this.search.bind(this);
    this.showModal = this.showModal.bind(this);
    this.export = this.export.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/colaboradores/listagens/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({staff_list: responseJson.data.staffs});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/questionario/pesquisa/fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({applicabilities_list: responseJson.data.applicabilities_list});
          self.setState({origins_list: responseJson.data.origins_list});
          self.setState({status_list: responseJson.data.status_list});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  export() {
    var self = this;
    var url = "/questionario/pesquisa/fadiga/exportar/" + this.state.data_modal.id;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }
  sendEmail(event) {
    var self = this;
    var url = "/questionario/pesquisa/fadiga/email/" + event.id;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      });
    });
  }

  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staff_ids: this.state.staff_ids,
      applicability_id: this.state.applicability_id,
      status: this.state.status,
      origins: this.state.origins,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fadiga/questionarios/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  showModal (event) {
    this.setState({ modal: true, data_modal:event.data_modal, date_str: event.date});
  }
  modalPropsOff (event) {
    this.setState({ modal: false, data_modal:[]});
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-success btn-sm" disabled={(row.status === 'respondido' ? 'disabled' : '')} onClick={() => { this.sendEmail(row); }}>
          <i className="fa fa-fw fa-envelope"></i>
        </button>
        <button className="btn btn-primary btn-sm" onClick={() => { this.showModal(row); }}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
      </div>
    );

    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.PesquisaDeRelatorios.titulo}</h3>
      <hr/>
      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PesquisaDeRelatorios.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                required
                placeholder={this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          {this.state.applicability_id === 1 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.PesquisaDeRelatorios.formulario.Tripulantes135}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChangeMulti.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                />
              </div>
            </div>
            : this.state.applicability_id === 4 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.PesquisaDeRelatorios.formulario.Tripulantes121}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChangeMulti.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                />
              </div>
            </div>
            : this.state.applicability_id === 2 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.PesquisaDeRelatorios.formulario.Mecanicos}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarMecanico}
                  onChange={this.handleSelectChangeMulti.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                />
              </div>
            </div>
            : this.state.applicability_id === 3 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.PesquisaDeRelatorios.formulario.Coordenadores}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarCoordenador}
                  onChange={this.handleSelectChangeMulti.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                />
              </div>
            </div>
            :
            ''
          }
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PesquisaDeRelatorios.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PesquisaDeRelatorios.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PesquisaDeRelatorios.formulario.MotivoDoEnvio}:</label>
              <Select
                className="form-field-name"
                name="origins"
                value={this.state.origins}
                searchable={true}
                placeholder={this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarMotivos}
                multi={true}
                onChange={this.handleSelectChangeMulti.bind(this, 'origins')}
                options={this.state.origins_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PesquisaDeRelatorios.formulario.Respondido}:</label>
              <Select
                className="form-field-name"
                name="status"
                value={this.state.status}
                searchable={true}
                placeholder={this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarStatus}
                multi={true}
                onChange={this.handleSelectChangeMulti.bind(this, 'status')}
                options={this.state.status_list}
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.PesquisaDeRelatorios.formulario.botaoProcurarQuestionarios}</button>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.PesquisaDeRelatorios.tituloListaDeQuestionarios}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.semQuestionarios}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="date" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>{this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>{this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Colaborador}</TableHeaderColumn>
        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>{this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="origin_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>{this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Motivo}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Acoes}</TableHeaderColumn>

      </BootstrapTable>
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">{this.locale.PesquisaDeRelatorios.tituloDadosDoQuestionarioDeFadiga} - {self.state.date_str}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <button onClick={self.export} className='btn btn-success btn-md'><i className="fa fa-fw fa-file-pdf-o" alt='Resultado de prova' title="Resultado da pesquisa"></i> {this.locale.PesquisaDeRelatorios.botaoExportarCSV}</button>
          <table className="table table-bordered table-stripped table-hover">
            <thead>
              <tr>
                <th className="text-center">{this.locale.PesquisaDeRelatorios.tabelaDadosDoQuestionario.Pergunta}</th>
                <th className="text-center">{this.locale.PesquisaDeRelatorios.tabelaDadosDoQuestionario.Resposta}</th>
              </tr>
            </thead>
            <tbody id="suppliers-certifications">
              {Object.keys(self.state.data_modal).map(function(k) {
                return (
                  <tr>
                    <td className="text-center">{self.state.data_modal[k]['name']}</td>
                    <td className="text-center">{self.state.data_modal[k]['value']}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default FatigueTestsIndex;



// WEBPACK FOOTER //
// ./src/Components/FatigueTests/FatigueTestsIndex.js